import { setLocale } from 'react-redux-i18n';

export function changeToChinese() {
  return dispatch => {
    dispatch(setLocale('ch'));
    localStorage.setItem('lang', 'ch');
  }
}

export function changeToEnglish() {
  return dispatch => {
    dispatch(setLocale('en'));
    localStorage.setItem('lang', 'en');
  }
}



// WEBPACK FOOTER //
// ./master/jsx/actions/language_actions.jsx